import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { useParams } from "react-router";
import { getDuration, getError } from "../../store/helpers/common_functions";
import React, { useContext, useEffect, useState, useMemo } from "react";
import PageLoading from "../../helpers/PageLoading";
import {
  Alert,
  Avatar,
  Button,
  CardActionArea,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment/moment";
import OpenDocument from "../../helpers/openDocument";
import { getFileMime, inArray } from "../../helpers/Common_functions";
import RequestTimeline from "../../helpers/timeline";
import FormDialog from "../../helpers/FormDialog";
import { CopyAll } from "@mui/icons-material";
import StyledBadge from "../../helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import { downloadUrl } from "../../Shared/commonFunction";
import OpenDocuments from "../../helpers/openDocument";
import ListTile from "../../helpers/ListTile";
import { StyledTableRow } from "helpers/CustomMenu";
import StatusLayout from "components/Status";
import SocketContext from "helpers/SocketContext";
import axios from "axios";
import BootstrapDialog from "../../helpers/BootStrapDialog";
import { errorToast, successToast } from "helpers/Notification";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function PermissionDetails({ FetchDetails, loggedUser, requestId }) {
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(0);
  const [leaveInfo, setLeaveInfo] = useState(null);

  const [allPositions, setAllPositions] = useState([]);
  const [value, setValue] = React.useState({});
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState();
  const [status, setStatus] = React.useState("");
  const [copies, setCopies] = React.useState([]);
  const [copyOpen, setCopyOpen] = React.useState(false);
  const [showDoc, setShowDoc] = React.useState(false);
  const [developers, setDevelopers] = React.useState([]);
  const [annualLeaveDetails, setAnnualLeaveDetails] = React.useState();
  const [documentType, setDocumentType] = React.useState("");
  const [documentId, setDocumentId] = React.useState("");
  const [showFinalDocument, setShowFinalDocument] = React.useState(false);
  const [search, setSearch] = React.useState();
  const [isLeaveSelected, setLeaveSelected] = React.useState(0);
  const [cancelling, setCancelling] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [approvalSteps, setApprovalSteps] = useState([]);
  const socket = useContext(SocketContext);
  const params = useParams();
  const id = requestId ?? params.id;
  const LeaveDetails = info?.leaveDetails ?? [];
  const Initiator = info?.request?.resource;

  useEffect(() => {
    const fetchApprovalSteps = async () => {
      if (info?.request?.resource?.positionId) {
        try {
          // console.log(
          //   "Fetching approval steps for position:",
          //   info.request.resource.positionId
          // );
          const resp = await axios.get(
            `/api/approval-process/by-position/${info.request.resource.positionId}`
          );
          // console.log("Approval steps response:", resp.data);
          if (resp.data?.data?.steps) {
            // Sort steps by order before setting state
            const sortedSteps = [...resp.data.data.steps].sort(
              (a, b) => a.order - b.order
            );
            setApprovalSteps(sortedSteps);
          }
        } catch (e) {
          console.error("Error fetching approval steps:", e);
        }
      }
    };

    fetchApprovalSteps();
  }, [info?.request?.resource?.positionId]);

  const canApprove = useMemo(() => {
    if (
      !info?.request ||
      !loggedUser?.Resource?.positionId ||
      !approvalSteps.length ||
      info?.request?.status === "denied" ||
      info?.request?.status === "approved" ||
      info?.request?.status === "canceled" ||
      info?.request?.status === "on-leave" // Add this condition
    ) {
      return false;
    }

    const currentStepIndex = info.request.approvalStepIndex ?? 0;
    const currentStep = approvalSteps[currentStepIndex];

    return currentStep?.approverPositionId === loggedUser.Resource.positionId;
  }, [info?.request, loggedUser?.Resource?.positionId, approvalSteps]);

  const getApprovalStatus = () => {
    if (!info?.request || !approvalSteps.length) return "";

    const status = info.request.status;

    // Early returns for final statuses
    if (status === "denied") {
      const denier = info.request?.deniedBy?.positionName || "Unknown Position";
      const denialStep = info.request.denialStep || "Unknown Step";
      return `Request Denied by ${denier} at ${denialStep}`;
    }
    if (status === "canceled") return "Request Canceled";
    if (status === "approved") return "Fully Approved";
    if (status === "on-leave") return ""; // Changed to return empty string
    if (status === "pending-review") return "Pending Initial Review";

    // Rest of the function remains the same
    const currentIndex = info.request.approvalStepIndex ?? 0;
    const totalSteps = approvalSteps.length;
    const nextStep = approvalSteps[currentIndex];
    const isLastStep = currentIndex === approvalSteps.length - 1;

    const approverName = nextStep?.approverPosition?.name || "Unknown Position";
    const stepNumber = currentIndex + 1;

    // Helper function to get step name
    const getStepName = () => {
      if (!status) return `Step ${stepNumber}`;

      const numbers = [
        "first",
        "second",
        "third",
        "fourth",
        "fifth",
        "sixth",
        "seventh",
        "eighth",
        "ninth",
        "tenth",
      ];

      // Try to extract the step number from status (e.g., "first-approval" -> "First")
      const stepMatch = status.match(/^(\w+)-approval$/);
      if (stepMatch) {
        const prefix = stepMatch[1];
        return `${prefix.charAt(0).toUpperCase()}${prefix.slice(1)} Approval`;
      }

      // Fallback to numeric step
      return numbers[currentIndex]
        ? `${numbers[currentIndex].charAt(0).toUpperCase()}${numbers[
            currentIndex
          ].slice(1)} Approval`
        : `Step ${stepNumber} Approval`;
    };

    const stepStatus = isLastStep ? "Final Approval" : getStepName();
    return `${stepStatus} - Waiting for ${approverName}'s approval (Step ${stepNumber}/${totalSteps})`;
  };
  let history = useHistory();


  const hasPendingAnnual =
    LeaveDetails?.find((item) => item.status === "pending") && canApprove;
  const isInitiator = info?.request?.resourceId === loggedUser?.Resource?.id;
  const hasFinalRejectedAnnual =
    LeaveDetails?.find(
      (item, index) =>
        item.status === "rejected" && index + 1 === LeaveDetails?.length
    ) && isInitiator;
  const hasApprovedAnnual = LeaveDetails?.find(
    (item) => item.status !== "pending" || item.status !== "rejected"
  );

  // Fetch All Positions
  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp.status) {
      setAllPositions(resp.data.list);
    } else {
      setError(getError(resp));
    }
    return resp;
  };

  useEffect(() => {
    loadPositions().then();
  }, []);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    const resp = await FetchDetails(`/api/request/details/${id}`);
    // console.log("Response from /api/request/details/:id", resp);
    setLoading(false);
    if (resp.status) {
      const leaveDetails =
        resp.data?.request?.LeaveDetails?.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ) ?? [];
      setInfo({
        ...resp.data,
        history: resp.data.history.sort((a, b) => {
          if (moment(a.createdAt).isAfter(b.createdAt)) {
            return 1;
          }

          return -1;
        }),
        leaveDetails,
      });
      setLeaveSelected(leaveDetails[0]?.id);
    } else {
      setError(getError(resp));
    }
    return resp;
  };

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  useEffect(() => {
    loadData(); // Fetch the latest leave details on component mount
    loadRelated().then();
  }, [id]);

  const loadRelated = async () => {
    const resp = await FetchDetails(`/api/request/list/resources`);
    if (resp.status) {
      setDevelopers(resp.data.data);
    }
  };

  const filterFunction = (v) => {
    const lower = search?.toLowerCase();
    return (
      !search ||
      v.names?.toLowerCase()?.includes(lower) ||
      v.category?.toLowerCase()?.includes(lower)
    );
  };

  const teamItem = (resource) => {
    const onClick = () => {
      if (copies.filter((v) => v === resource.id).length > 0) {
        setCopies((old) => old.filter((i) => i !== resource.id));
      } else {
        setCopies((old) => [...old, resource.id]);
      }
    };

    let checked = copies.filter((v) => v === resource.id).length > 0;

    return (
      <div className={`mr-2 relative mb-3 text-center`}>
        <div
          className={"absolute right-0"}
          style={{ zIndex: "10", top: "-10px" }}
        >
          <Checkbox onChange={onClick} checked={checked} />
        </div>
        <CardActionArea onClick={onClick}>
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Avatar
              sx={{ bgcolor: grey[300], width: 60, height: 60 }}
              src={
                resource.profile
                  ? `${downloadUrl}/${resource.profile}`
                  : undefined
              }
              alt={resource.names}
            />
          </StyledBadge>
          <div style={{ width: "130px" }}>
            <Typography
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
              variant={"body2"}
            >
              {resource.names}
            </Typography>
            <div>
              <Typography
                sx={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                }}
                variant={"subtitle2"}
                style={{ fontWeight: "bold" }}
              >
                {resource.positionName || "N/A"}
              </Typography>
            </div>
          </div>
        </CardActionArea>
      </div>
    );
  };

  let isApprove = status === "approved" || status === "first-approval";

  const copyList = info?.history?.filter((v) => v.status === "copy");

  let leaveDays = info?.request?.category?.leaveDays;
  let categryId = info?.request?.category?.id;
  let message = info?.request?.category?.message;
  let taken = Initiator?.leaveDays ?? 0;

  leaveDays = (leaveDays ?? 0) + (info?.request?.carryoverDays ?? 0) - taken;

  if (info?.request?.category?.type === "annual") {
    leaveDays = info?.request?.remainingDays;
  }

  const searchView = (
    <div className={"flex p-3"}>
      <div className={"flex-grow"}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={"Search here ..."}
          type={"text"}
          className={
            "px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150"
          }
        />
      </div>
    </div>
  );

  // Cancel leave handler
  const handleCancelRequest = async () => {
    setCancelling(true);
    try {
      const resp = await FetchDetails(`/api/request/cancel/${id}`, {
        method: "POST",
      });
      if (resp.status) {
        await loadData();
        setCancelDialogOpen(false);
        // Optionally show a success toast
        successToast("Request cancelled successfully");
      } else {
        setError(getError(resp));
        errorToast(getError(resp) || "Failed to cancel request");
      }
    } catch (e) {
      setError(e?.message || "Failed to cancel request");
      errorToast(e?.message || "Failed to cancel request");
    }
    setCancelling(false);
  };

  // Update the handleApproval function to explicitly set denial status
  const handleApproval = (status) => {
    setOpen(true);
    setStatus(status); // This should be either "denied" or "approved"
  };

  // Add this function to transform history items for the timeline
  const getTimelineContent = (history) => {
    if (!history) return [];

    return history
      ?.filter(
        (v) =>
          // Exclude both copy and pending-review statuses
          v.status !== "copy" && v.status !== "pending-review"
      )
      ?.reduce((unique, item) => {
        const exists = unique.find(
          (u) =>
            u.resourceId === item.resourceId &&
            u.status === item.status &&
            u.stepIndex === item.stepIndex
        );
        if (exists) return unique;

        // Add step information to the history item
        const stepIndex = item.stepIndex;
        const step = approvalSteps[stepIndex];

        // For denied or canceled status, override the stepName
        const status = item.status;
        let stepName;
        if (status === "denied") {
          stepName = "Request Denied";
        } else if (status === "canceled") {
          stepName = "Request Canceled";
        } else {
          stepName = step
            ? `${step.approverPosition?.name || "Unknown"} Approval`
            : item.status;
        }

        return [
          ...unique,
          {
            ...item,
            stepName,
            stepIndex: stepIndex,
          },
        ];
      }, []);
  };

  const getHistoryForDetail = (selectedDetailId) => {
    if (!selectedDetailId || !LeaveDetails?.length || !info?.history?.length) {
      return info?.history ?? [];
    }
    const sortedDetails = [...LeaveDetails].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
    const selectedIdx = sortedDetails.findIndex((d) => d.id === selectedDetailId);
    if (selectedIdx === -1) return info?.history ?? [];
    const selectedDetail = sortedDetails[selectedIdx];
    const nextDetail = sortedDetails[selectedIdx + 1];

    return (info?.history ?? [])
      .filter((h) => h.status !== "copy")
      .filter((h) => {
        const hTime = new Date(h.createdAt).getTime();
        const start = new Date(selectedDetail.createdAt).getTime();
        const end = nextDetail
          ? new Date(nextDetail.createdAt).getTime()
          : Infinity;
        return hTime >= start && hTime < end;
      })
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  };

  const ApprovalStepsOverview = ({ steps }) => {
    const currentStepIndex = info?.request?.approvalStepIndex ?? 0;
    const isDenied = info?.request?.status === "denied";
    const isCanceled = info?.request?.status === "canceled";

    // Ensure steps are in correct order
    const sortedSteps = [...steps].sort((a, b) => a.order - b.order);

    return (
      <div className={"w-full md:w-6/12 lg:w-6/12 justify-end"}>
        <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
          Approval Flow
        </h3>
        <div className="mb-3 text-blueGray-600 mt-0 flex items-center flex-wrap">
          <i className="fas fa-sitemap mr-2 text-lg text-blueGray-400"></i>
          <div className="flex items-center flex-wrap gap-2">
            {sortedSteps.map((step, index) => (
              <React.Fragment key={step.id}>
                <Chip
                  size="small"
                  label={step.approverPosition?.name || "Unknown"}
                  sx={{
                    backgroundColor:
                      (isDenied || isCanceled) && index === currentStepIndex
                        ? "#ef5350" // Red background for denied/canceled step
                        : index < currentStepIndex
                        ? "#52b69a" // Green for completed steps
                        : index === currentStepIndex
                        ? "#52b69a" // Green for current step
                        : "#E0E0E0", // Gray for future steps
                    color:
                      (isDenied || isCanceled) && index === currentStepIndex
                        ? "white"
                        : "black",
                    fontWeight: "500",
                  }}
                />
                {index < sortedSteps.length - 1 && (
                  <i
                    className={`fas fa-arrow-right mx-2 ${
                      index < currentStepIndex
                        ? "text-blueGray-600"
                        : "text-blueGray-300"
                    }`}
                  ></i>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <FormDialog
          onSuccess={loadData}
          url={`/api/request/update/${id}`}
          formAlert={<div dangerouslySetInnerHTML={{ __html: message }} />}
          maxWidth={"md"}
          col={6}
          title={"Edit this Leave Request"}
          open={openEdit}
          setOpen={() => {
            setOpenEdit(0);
          }}
          fields={[
            {
              name: "startDate",
              type: "date",
              value: value["startDate"],
              label: "Start Date",
              required: true,
              setValue: (val) => setValue0("startDate", val),
            },
            {
              name: "categoryId",
              type: "text",
              value: categryId,
              label: "Category",
              hidden: true,
            },
            {
              name: "detailsId",
              type: "text",
              value: leaveInfo?.id,
              label: "Details",
              hidden: true,
            },
            {
              name: "endDate",
              type: "date",
              label: "Return Date",
              value: value["endDate"],
              maxDate:
                leaveDays && value["startDate"]
                  ? moment(value["startDate"]).add(leaveDays, "days")
                  : null,
              minDate: value["startDate"]
                ? moment(value["startDate"]).add(1, "day")
                : null,
              required: true,
              setValue: (val) => setValue0("endDate", val),
            },
            {
              name: "leaveDays",
              type: "number",
              label: "Requested Days",
              disabled: true,
              required: false,
              value:
                value["startDate"] && value["endDate"]
                  ? moment(value["endDate"]).businessDiff(
                      moment(value["startDate"])
                    )
                  : null,
            },
            {
              name: "maxDays",
              type: "number",
              label: "Max Leave Days",
              disabled: true,
              // hidden:!selectedValue?.leaveDays,
              value: leaveDays,
            },
            {
              name: "supportDocument",
              type: "file-drag",
              label: "Support Document",
              value: value["supportDocument"],
              required: false,
              setValue: (val) => setValue0("supportDocument", val),
            },
          ]}
        />
        <Dialog
          open={copyOpen}
          fullWidth={true}
          maxWidth={"md"}
          onClose={() => setCopyOpen(false)}
        >
          <DialogContent>
            <div>
              <div className={"mb-5"}>{searchView}</div>
              <div className={"flex flex-wrap justify-center"}>
                {developers.filter(filterFunction).map((v) => teamItem(v))}
              </div>

              <div className={"text-center mt-5"}>
                <Button color={"error"} onClick={() => setCopyOpen(false)}>
                  Close
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          maxWidth={"md"}
          fullWidth={true}
          open={showDoc}
          onClose={() => setShowDoc(false)}
        >
          {showDoc && (
            <OpenDocument
              downloadable={true}
              document={info?.request?.supportDocument}
              mimeType={getFileMime(info?.request?.supportDocument)}
            />
          )}
        </Dialog>
        <FormDialog
          onSuccess={(response) => {
            const updatedRequest = response?.data?.data;
            if (updatedRequest) {
              setInfo((prev) => ({
                ...prev,
                request: updatedRequest,
                history: [
                  ...(prev.history || []),
                  {
                    resourceId: loggedUser.Resource.id,
                    status: updatedRequest.status,
                    createdAt: new Date(),
                    Resource: loggedUser.Resource,
                    stepIndex: updatedRequest.approvalStepIndex,
                    comment: value.comment,
                  },
                ],
              }));
            }
            loadData();
            // window.location.reload(); // TEMP: force full reload to ensure fresh data
            if (socket && loggedUser?.Resource && info?.request) {
              socket.emit("sendNotification", {
                message: `Your request has been ${
                  ["approved", "first-approval", "second-approval"].includes(
                    status
                  )
                    ? "Approved"
                    : "Denied"
                } by ${loggedUser.Resource.names}`,
                resourceId: loggedUser.Resource.id,
                receiverId: info.request.resourceId,
                type: `leave-${
                  ["approved", "first-approval", "second-approval"].includes(
                    status
                  )
                    ? "approved"
                    : "denied"
                }`,
              });
            }
          }}
          url={`/api/approval/approve/request/${id}`}
          buttonColor={
            ["approved", "first-approval", "second-approval"].includes(status)
              ? "success"
              : "error"
          }
          buttonTitle={
            ["approved", "first-approval", "second-approval"].includes(status)
              ? "Approve"
              : "Deny"
          }
          open={open}
          setOpen={() => setOpen(false)}
          title={
            status === "denied"
              ? "Deny this leave request"
              : ["approved", "first-approval", "second-approval"].includes(
                  status
                )
              ? "Approve this leave/permission"
              : "Take action on this leave request"
          }
          fields={[
            {
              name: "comment",
              type: "textarea",
              label: "Comment",
              value: value["comment"],
              required: true,
              setValue: (val) => setValue0("comment", val),
            },
            {
              name: "status",
              type: "hidden",
              hidden: true,
              label: "Comment",
              value: status,
            },
            {
              name: "annualLeaveDetails",
              type: "hidden",
              hidden: true,
              label: "leaveDetails",
              value: annualLeaveDetails ?? isLeaveSelected,
            },
            {
              name: "copies",
              type: "text",
              render: () => (
                <div>
                  <Button
                    variant={"outlined"}
                    onClick={() => setCopyOpen(true)}
                    startIcon={<CopyAll />}
                  >
                    Copy Other Users ({copies?.length})
                  </Button>
                </div>
              ),
              hidden: status !== "approved", // Only show for approval
              label: "Add Copies",
              value: copies,
            },
          ]}
        />
        <div className={"flex flex-wrap"}>
          <div className="w-full xl:w-12/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 pb-6 shadow-lg rounded-lg border-0">
              <div className="rounded bg-white mb-0 px-0 py-0 overflow-hidden">
                {loading ? <LinearProgress /> : null}
                <div className="px-6 py-6">
                  <div className="mt-0">
                    <div className="text-xl leading-normal mt-0 mb-3 text-blueGray-400 font-bold uppercase">
                      {info?.request?.category?.type === "annual"
                        ? `${
                            !isInitiator
                              ? `${Initiator?.names}:${info?.request?.year} Annual Leave Plan`
                              : "My Annual Leave Plan"
                          }`
                        : info?.request?.category?.name}
                    </div>
                    <div className={"flex flex-wrap"}>
                      {info?.request?.category?.type === "annual" ? (
                        <>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Remaining Days
                            </h3>
                            <div className="mb-3 text-blueGray-600 mt-0">
                              <i className="fas fa-list mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.remainingDays}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Carried over Days
                            </h3>
                            <div className="mb-3 text-blueGray-600 mt-0">
                              <i className="fas fa-forward mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.carryoverDays}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Unused Days
                            </h3>
                            <div className="mb-3 text-blueGray-600 mt-0">
                              <i className="fas fa-close mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.canceledDate}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Days Taken
                            </h3>
                            <div className="mb-3 text-blueGray-600 mt-0">
                              <i className="fas fa-check mr-2 text-lg text-blueGray-400"></i>
                              {LeaveDetails.reduce(
                                (total, item) =>
                                  total + (item.numberOfDays ?? 0),
                                0
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {!isInitiator ? (
                            <div className={"w-full md:w-3/12 lg:w-3/12"}>
                              <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                                Requestor
                              </h3>
                              <div className="mb-3 text-blueGray-600">
                                <i className="fas fa-user mr-2 text-lg text-blueGray-400"></i>
                                {Initiator?.names}
                              </div>
                            </div>
                          ) : null}
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Leave Start - Return date
                            </h3>
                            <div className="mb-3 text-blueGray-600 mt-0">
                              <i className="fas fa-clock mr-2 text-lg text-blueGray-400"></i>
                              {moment(info?.request?.startDate).format(
                                "YYYY-MMM-DD"
                              )}
                              <span className={"px-2"}>
                                <i className={"fas fa-arrow-right"}></i>
                              </span>
                              {moment(info?.request?.endDate).format(
                                "YYYY-MMM-DD"
                              )}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Leave Duration
                            </h3>
                            <div className="mb-3 text-blueGray-600 mt-0">
                              <i className="fas fa-clock mr-2 text-lg text-blueGray-400"></i>
                              {getDuration(
                                info?.request?.endDate,
                                info?.request?.startDate
                              )}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Location
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-university mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.location}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Support Document
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-file mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.supportDocument ? (
                                <Button
                                  onClick={() => {
                                    setShowDoc(true);
                                  }}
                                  size={"small"}
                                >
                                  View
                                </Button>
                              ) : (
                                <span>No doc available !</span>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {approvalSteps?.length > 0 && (
                        <ApprovalStepsOverview steps={approvalSteps} />
                      )}
                    </div>

                    <div className={"flex flex-wrap items-center"}>
                      <div
                        className={"w-full md:w-3/12 lg:w-3/12"}
                        style={{ marginTop: "-5px" }}
                      >
                        <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                          Status
                        </h3>
                        <div className="text-blueGray-600">
                          <StatusLayout status={info?.request?.status} />
                        </div>
                      </div>
                      {info?.request?.category?.type === "study" ? (
                        <>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Country
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-globe mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.country}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              School Name
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-university mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.schoolName}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Education Level
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-graduation-cap mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.educationLevel}
                            </div>
                          </div>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Course to be attended
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-book mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.course}
                            </div>
                          </div>
                        </>
                      ) : null}
                      {info?.request?.category?.type === "sick" ? (
                        <>
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Country
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-globe mr-2 text-lg text-blueGray-400"></i>
                              {info?.request?.country}
                            </div>
                          </div>
                          {/*<div className={'w-full md:w-3/12 lg:w-3/12'}>*/}
                          {/*    <h3 className="text-sm font-semibold leading-normal text-blueGray-700">*/}
                          {/*        Illness Type*/}
                          {/*    </h3>*/}
                          {/*    <div className="mb-3 text-blueGray-600">*/}
                          {/*        <i className="fas fa-heartbeat mr-2 text-lg text-blueGray-400"></i>*/}
                          {/*        {info?.request.illnessType}*/}
                          {/*    </div>*/}
                          {/*</div>*/}
                          <div className={"w-full md:w-3/12 lg:w-3/12"}>
                            <h3 className="text-sm font-semibold leading-normal text-blueGray-700">
                              Hospital Name
                            </h3>
                            <div className="mb-3 text-blueGray-600">
                              <i className="fas fa-hospital mr-2 text-lg text-blueGray-400"></i>
                              {info?.request.hospitalName}
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  {info?.request?.description ? (
                    <div className="mt-5 border-t border-blueGray-200 text-center">
                      <div className="flex flex-wrap justify-center mt-5">
                        <div className="w-full lg:w-12/12 px-4">
                          <p className="mb-4 text-lg leading-relaxed text-blueGray-700">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: info?.request.description,
                              }}
                            ></div>
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {showFinalDocument ? (
                    <div className={"flex flex-wrap justify-center"}>
                      <div className={"w-full lg:w-8/12 xl:w-8/12 px-4"}>
                        {/* 'final-permission-doc' */}

                        <OpenDocuments
                          width={"100%"}
                          type={documentType}
                          mimeType={"application/pdf"}
                          downloadable={true}
                          document={documentId}
                          card={true}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
                {/* add leave details if is annual leave  */}
                {LeaveDetails?.length ? (
                  <TableContainer>
                    <Table size={"small"}>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Start date</TableCell>
                          <TableCell>Return date</TableCell>
                          <TableCell>Days</TableCell>
                          <TableCell>Status</TableCell>
                          {hasApprovedAnnual ? (
                            <TableCell>Attachment</TableCell>
                          ) : null}
                          {hasPendingAnnual ? (
                            <TableCell>Action</TableCell>
                          ) : null}
                          {hasFinalRejectedAnnual ? (
                            <TableCell>Edit</TableCell>
                          ) : null}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {LeaveDetails?.map((item, index) => (
                          <StyledTableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={isLeaveSelected === item?.id}
                                onClick={() => {
                                  setLeaveSelected(item?.id);
                                }}
                              />
                            </TableCell>
                            {/* <TableCell>{index + 1}</TableCell> */}
                            <TableCell>
                              {moment(item?.startDate).format("DD/MM/YYYY")}
                            </TableCell>
                            <TableCell>
                              {moment(item?.endDate).format("DD/MM/YYYY")}
                            </TableCell>
                            <TableCell>{item?.numberOfDays}</TableCell>
                            <TableCell>
                              <StatusLayout status={item?.status} />
                            </TableCell>
                            <TableCell>
                              {item?.status !== "pending" &&
                              item?.status !== "rejected" ? (
                                "None"
                              ) : (
                                <Button
                                  onClick={() => {
                                    setDocumentType("annual");
                                    setShowFinalDocument(!showFinalDocument);
                                    setDocumentId(item.id);
                                  }}
                                >
                                  {" "}
                                  <i className="fas fa-file mr-2 text-lg text-blueGray-400"></i>{" "}
                                  {showFinalDocument ? "Close" : "Open"}
                                </Button>
                              )}
                            </TableCell>

                            {hasPendingAnnual ? (
                              <TableCell>
                                {item?.status === "pending" && (
                                  <>
                                    <Button
                                      color="success"
                                      size="small"
                                      onClick={() => {
                                        setOpen(true);
                                        setStatus(
                                          info?.request?.status ===
                                            "pending-review"
                                            ? "first-approval"
                                            : "approved"
                                        );
                                        setAnnualLeaveDetails(item.id);
                                      }}
                                    >
                                      {info?.request?.status ===
                                      "pending-review"
                                        ? "First Approval"
                                        : "Approve"}
                                    </Button>
                                    <Button
                                      color="error"
                                      size="small"
                                      onClick={() => {
                                        setOpen(true);
                                        setStatus("denied");
                                        setAnnualLeaveDetails(item.id);
                                      }}
                                    >
                                      Reject
                                    </Button>
                                  </>
                                )}
                              </TableCell>
                            ) : null}
                            {hasFinalRejectedAnnual ? (
                              <TableCell>
                                {item?.status === "rejected" &&
                                  index + 1 === LeaveDetails?.length && (
                                    <>
                                      <Button
                                        color="success"
                                        size="small"
                                        onClick={() => {
                                          setOpenEdit(1);
                                          setLeaveInfo(item);
                                          setValue0(
                                            "startDate",
                                            moment(item?.startDate).format(
                                              "YYYY-MM-DD"
                                            )
                                          );
                                          setValue0(
                                            "endDate",
                                            moment(item?.endDate).format(
                                              "YYYY-MM-DD"
                                            )
                                          );
                                        }}
                                      >
                                        Edit & Resend
                                      </Button>
                                    </>
                                  )}
                              </TableCell>
                            ) : null}
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : null}
                {/* end leave details */}

                {copyList?.length > 0 && (
                  <div className={"p-5"}>
                    <div>
                      <Typography variant={"h5"}>Request Copies</Typography>
                    </div>
                    <div className={"flex flex-wrap"}>
                      {copyList?.map((v) => (
                        <div className={"w-full lg:w-4/12 xl:w-4/12 px-4"}>
                          <ListTile
                            showAvatar={true}
                            item={{
                              label: v.Resource?.names ?? "",
                              secondary: v.Resource?.positionName ?? "",
                            }}
                            handleToggle={() => {
                              history.push(`/admin/profile/${v.Resource?.id}`);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className={"p-5 text-center"}>
                  <Typography variant={"h5"}>Approval Process</Typography>
                </div>
                <div className={"flex"}>
                  <RequestTimeline
                    content={getTimelineContent(
                      isLeaveSelected && LeaveDetails?.length > 0
                        ? getHistoryForDetail(isLeaveSelected)
                        : info?.history
                    )}
                  />
                </div>
                {(LeaveDetails?.length > 0 &&
                  LeaveDetails?.find((item) => item.id === isLeaveSelected)
                    ?.status === "pending" &&
                  info?.request?.category?.type === "annual" &&
                  canApprove) ||
                (canApprove &&
                  !hasPendingAnnual &&
                  inArray(
                    ["pending-review", "under-review"],
                    info?.request?.status
                  )) ||
                (canApprove &&
                  info?.request?.status !== "denied" &&
                  info?.request?.status !== "canceled") ? (
                  // Hide if denied/rejected/canceled
                  info?.request?.status === "denied" ||
                  info?.request?.status === "canceled" ||
                  LeaveDetails?.find((item) => item.id === isLeaveSelected)
                    ?.status === "rejected" ? null : (
                    <div className={"p-5 flex justify-end"}>
                      <Button
                        color="error"
                        onClick={() => handleApproval("denied")} // Always use "denied" for rejection
                      >
                        Deny
                      </Button>
                      <Button
                        color="success"
                        onClick={() =>

                          {
                            // console.log("Resource ID:", info);
                            handleApproval(
                            info?.request?.status === "pending-review"
                              ? "first-approval"
                              : "approved"
                          ) }
                        }
                      >
                        Approve
                      </Button>
                    </div>
                  )
                ) : info?.request?.status !== "approved" &&
                  info?.request?.status !== "denied" &&
                  info?.request?.status !== "canceled" ? (
                  <div className={"flex justify-center"}>
                    <div>
                      {/* Only show Alert if there's a status message */}
                      {getApprovalStatus() && (
                        <Alert severity={"info"}>{getApprovalStatus()}</Alert>
                      )}
                    </div>
                  </div>
                ) : null}
                <div className={"p-5 flex justify-end"}>
                  {/* Cancel button for request owner - only show if not canceled/denied/approved and not past end date */}
                  {isInitiator &&
                    info?.request?.status !== "canceled" &&
                    info?.request?.status !== "denied" &&
                    info?.request?.status !== "approved" &&
                    moment().isBefore(moment(info?.request?.endDate)) && (
                      <div className="mb-4 mr text-right">
                        <Button
                          color="error"
                          variant="outlined"
                          disabled={cancelling}
                          onClick={() => setCancelDialogOpen(true)}
                        >
                          {cancelling ? "Cancelling..." : "Cancel Leave"}
                        </Button>
                        <BootstrapDialog
                          open={cancelDialogOpen}
                          onClose={() => setCancelDialogOpen(false)}
                          maxWidth="xs"
                          fullWidth
                        >
                          <DialogTitle>Cancel Leave Request</DialogTitle>
                          <DialogContent>
                            <Typography>
                              Are you sure you want to cancel this leave
                              request?
                            </Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setCancelDialogOpen(false)}>
                              No
                            </Button>
                            <Button
                              color="error"
                              onClick={handleCancelRequest}
                              disabled={cancelling}
                            >
                              Yes, Cancel
                            </Button>
                          </DialogActions>
                        </BootstrapDialog>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PermissionDetails);
